import { Fade, Grid } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { EducationalHighlight } from '../../generated/graphql';
import useEducationalHighlights from '../../hooks/useEducationalHighlights';
import Paragraph from '../Paragraph/Paragraph';
import Typography from '../Typography/Typography';
import styles from './EducationalHighlights.module.scss';

export default function EducationalHighlights() {

    const history = useHistory()

    const { educationalHighlights, loading } = useEducationalHighlights()

    const handleClick = (highlight: EducationalHighlight) => {
        const url = highlight.route
        if (url.startsWith("http")) {
            window.location.href = url
        } else {
            history.push(url)
        }
    }

    return (
        <Fade in={!loading}>
            <Grid container className={styles.EducationalHighlights}>
                <Grid container justify="center">
                    <Typography variant="RocGroteskBold25" className={styles.Name}>
                        Destaques
                    </Typography>
                </Grid>
                <Grid item container justify="center" className={styles.Highlights}>
                    {educationalHighlights?.map((highlight: EducationalHighlight) => (
                        <div className={styles.SectionHighlight} onClick={() => handleClick(highlight as any)} key={highlight.id}>
                            <img src={highlight.image} alt={highlight.date} />
                            <Paragraph variant="RocGroteskBold20" className={styles.Link}>
                                {highlight.name}
                            </Paragraph>
                        </div>
                    ))}
                </Grid>
            </Grid>
        </Fade>
    )
}
